import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, ToastController } from 'ionic-angular';
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import { LoadingProvider } from '../../providers/loading/loading';
import { Http, Headers, RequestOptions } from '@angular/http';
import { ViewContactPage } from '../view-contact/view-contact';
import {EnvDataService} from '../../app/services/env-data-service';
@Component({
  selector: 'page-add-contact',
  templateUrl: 'add-contact.html',
  providers:[EnvDataService]
})
export class AddContactPage {

  addContactForm: FormGroup;
    public form_name: any;
    public uid: any;
    public firstname: any;
    public lastname: any;
    public email: any;
    public header_title: any;
    public allBrokers: any;
    public userRole: any;

    public validation_messages = {
      'firstname': [
          { type: 'required', message: 'Firstname is required.' }
      ],
      'lastname': [
        { type: 'required', message: 'Lastname is required.' }
      ],
      'email': [
        { type: 'required', message: 'Email is required.' }
      ],
      'reference_broker': [
        { type: 'required', message: 'Please select broker.' }
      ],
      'mobile_phone': [
        { type: 'required', message: 'Mobile Number is required.' },
        { type: 'minlength', message: 'Mobile Number must be at least 10 digit long.' },
        { type: 'maxlength', message: 'Mobile Number must be at least 10 digit long.' }
      ]
    }
    
  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams, 
    public formBuilder: FormBuilder, 
    public afs: AngularFirestore, 
    public modalCtrl: ModalController, 
    public afAuth:AngularFireAuth, 
    public toastCtrl: ToastController,
    public loadingProvider: LoadingProvider,
    public http: Http,
    public db: AngularFirestore,
    private EnvDataService:EnvDataService
  ) {
    debugger;
    
    this.form_name = "eLINK Finance";
    this.header_title = "Add New Contact";
    this.addContactForm = formBuilder.group({
      firstname: ['', Validators.compose([Validators.required])],
      lastname: ['', Validators.compose([Validators.required])],
      mobile_phone: ['', Validators.compose([Validators.required, Validators.minLength(12), Validators.maxLength(12)])],
      email: ['', Validators.compose([Validators.required, Validators.email])],
      reference_broker: [''],
    }); 

    this.getAllBrokers().subscribe((data)=>{
      this.allBrokers = data;
    });

    this.userRole = window.localStorage.getItem("userRole");
    if(this.userRole == 'super_admin'){
      let reference_broker = this.addContactForm.get('reference_broker');
      reference_broker.setValidators(Validators.required);
      reference_broker.updateValueAndValidity();
    }
  }

  getAllBrokers (){
    return this.db.collection<any>( "users" , ref => ref.where('roles.broker','==',true )).valueChanges ();
  }

  isFieldValid(field: string) {
    return !this.addContactForm.get(field).valid && this.addContactForm.get(field).touched;
  }
  
  displayFieldCss(field: string) {
    return {
      'has-error': this.isFieldValid(field),
      'has-feedback': this.isFieldValid(field)
    };
  }

  add_contact(){
    if(!this.addContactForm.valid){
      this.addContactForm.get('lastname').markAsDirty();
      this.addContactForm.get('lastname').markAsTouched();

      this.addContactForm.get('firstname').markAsDirty();
      this.addContactForm.get('firstname').markAsTouched();

      this.addContactForm.get('mobile_phone').markAsDirty();
      this.addContactForm.get('mobile_phone').markAsTouched();

      this.addContactForm.get('email').markAsDirty();
      this.addContactForm.get('email').markAsTouched();

      this.addContactForm.get('reference_broker').markAsDirty();
      this.addContactForm.get('reference_broker').markAsTouched();

    }else{
      this.loadingProvider.startLoading();
      let uid = window.localStorage.getItem("uid");
      if(uid != null){
        let firstname = this.addContactForm.value.firstname;
        let lastname = this.addContactForm.value.lastname;      
        let email = this.addContactForm.value.email;
        let mobile_phone = this.addContactForm.value.mobile_phone; 
        let reference_broker = this.addContactForm.value.reference_broker; 
        let password = this.stringGen(10);     

        var headers = new Headers();
        headers.append("Accept", 'application/json');
        headers.append('Content-Type', 'application/json' );
        const requestOptions = new RequestOptions({ headers: headers });

        let postData = {
          "super_admin_uid": uid,
          "displayName": firstname,
          "email": email,
          "phoneNumber": "+6"+mobile_phone.split(" ").join(""),
          "password": password,
          "firstname": firstname,
          "lastname": lastname,
          "mobile_phone": mobile_phone,
          "created_date" : new Date().getTime()
        }

        if(window.localStorage.getItem("userRole") == "broker"){
          postData['reference_broker'] = uid;
        }else{
          postData['reference_broker'] = reference_broker;
        }

        postData['brokerFirstname'] = window.localStorage.getItem("brokerFirstname");
        postData['brokerLastname'] = window.localStorage.getItem("brokerLastname");
        postData['brokerEmail'] = window.localStorage.getItem("email");

        var url = this.EnvDataService.EnvData.sendbox_api+"/createContact";

        this.http.post(url, postData, requestOptions)
        .subscribe(data => {
          console.log(data);
          if(data['_body'] == 'The email address is already in use by another account.'){
            this.loadingProvider.stopLoading();  
            this.presentToast(data['_body']);          
          }else if(data['_body'] == 'The user with the provided phone number already exists.'){
            this.loadingProvider.stopLoading();
            this.presentToast(data['_body']);
          }else if(data['_body'] == 'TOO_LONG'){
            this.loadingProvider.stopLoading();
            this.presentToast('Invalid Phone Number.');
          }else if(data['_body'] == 'TOO_SHORT'){
            this.loadingProvider.stopLoading();
            this.presentToast('Invalid Phone Number.');
          }else if(data['_body'] == 'Invalid format.'){
            this.loadingProvider.stopLoading();
            this.presentToast('Invalid Phone Number.');
          }else if(data['_body'] == 'The phone number must be a non-empty E.164 standard compliant identifier string.'){
            this.loadingProvider.stopLoading();
            this.presentToast('Invalid Phone Number.');
          }else if(data['_body'] == 'The email address is improperly formatted.'){
            this.loadingProvider.stopLoading();
            this.presentToast('Invalid Email Address.');
          }else{
            this.loadingProvider.stopLoading();
            console.log(data['_body'])
            let responseData = JSON.parse(data['_body']);
            window.localStorage.setItem("contact_uid", responseData.contact_uid);
            window.localStorage.setItem("SDF_form_document_id", responseData.SDF_form_document_id);
            this.navCtrl.push(ViewContactPage);
          }
        }, error => {
          this.loadingProvider.stopLoading();
          this.presentToast(error.message);
        });
      }
    }
  }

  presentToast(err) {
    const toast = this.toastCtrl.create({
      message: err,
      duration: 3000,
      position: 'bottom'
    });

    toast.present();
  }

  ionViewDidLoad() {
  }

  phoneInput(event) {
    //48 - 57
    let pass = /[4][8-9]{1}/.test(event.charCode) || /[5][0-7]{1}/.test(event.charCode);
    if (!pass) {
      return false;
    }
  }

  setFormatNumber(event) {
    var mobile_phone = this.addContactForm.controls.mobile_phone.value;
    mobile_phone = mobile_phone.split(" ").join("");
    let firstFour = mobile_phone.slice(0, 4);
    let number = mobile_phone.slice(4, 10);
    number = firstFour + ' ' + number.slice(0, 3) + ' ' + number.slice(3);
    this.addContactForm.controls.mobile_phone.setValue(number.trim());
  }

  onPaste(event) {
    let clipboardData = event.clipboardData;
    let pastedText = clipboardData.getData('text');
    pastedText = pastedText.split(" ").join("");
    let firstFour = pastedText.slice(0, 4);
    let number = pastedText.slice(4, 10);
    number = firstFour + ' ' + number.slice(0, 3) + ' ' + number.slice(3);
    this.addContactForm.controls.mobile_phone.setValue('');
    this.addContactForm.controls.mobile_phone.setValue(number.trim());
  }

  stringGen(len) {
    var text = "";
    var charset = "abcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < len; i++)
      text += charset.charAt(Math.floor(Math.random() * charset.length));
    return text;
  }

}




// WEBPACK FOOTER //
// ./src/pages/add-contact/add-contact.ts